<template>
  <div class="admin-shops-requests-index">
    <header-component></header-component>
    <md-layout md-align="center">
      <md-layout md-column md-flex="90">
        <h2>リクエスト一覧</h2>
        <table class="request-table">
          <tr>
            <td>店舗名</td>
            <td>推薦の言葉</td>
            <td>削除ボタン</td>
          </tr>
          <tr v-for="request in shopRequests" :key="request.doc_id">
            <td width="20%"><router-link :to="{ name: 'AdminShopRequestsShopsNew', params: { id: request.doc_id }}">{{ request.name }}</router-link></td>
            <td width="70%">{{ request.comment }}</td>
            <td width="10%"><md-button class="md-icon-button" v-on:click="deleteRequest(request)"><md-icon>delete</md-icon></md-button></td>
        　</tr>
        </table>
      </md-layout>
    </md-layout>
  </div>
</template>
<script>
import HeaderComponent from '../../Header.vue'
import firebaseApp from '../../../firebaseApp'
import authenticateUser from '../../../auth'
const db = firebaseApp.firestore()

let data = {
  shopRequests: []
}

export default {
  name: 'admin-shops-requests-index',
  data: function () {
    return data
  },
  components: {
    HeaderComponent
  },
  created () {
    authenticateUser().then(function (user) {
      db.collection('shop_requests').get().then(function (documentSnapshots) {
        documentSnapshots.forEach(function (doc) {
          data.shopRequests.push(Object.assign(doc.data(), { doc_id: doc.id }))
        })
      })
    })
  },
  destroyed () {
    data.shopRequests = []
  },
  methods: {
    deleteRequest (request) {
      if (confirm('リクエストを削除してもよろしいですか？')) {
        db.doc(`shop_requests/${request.doc_id}`).delete().then(function () {
          data.shopRequests = data.shopRequests.filter(function (shopRequest) {
            return shopRequest.doc_id !== request.doc_id
          })
        }).catch(function (error) {
          alert(error + 'リクエストの削除に失敗しました。もう一度削除してください。')
        })
      }
    }
  }
}
</script>
<style scoped>
.request-table {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/ShopRequests/Index.vue